export const calculateIslemAnindaBakiyeMap = (rows = []) => {
  const list = [...rows].sort((a, b) => {
    const ta = a?.tarih ? new Date(a.tarih).getTime() : 0;
    const tb = b?.tarih ? new Date(b.tarih).getTime() : 0;
    if (ta !== tb) return ta - tb;
    return (a.id || 0) - (b.id || 0);
  });

  let tl = 0, usd = 0, eur = 0, gram = 0;

  const ziynet = {
    "Yeni ATA": 0,
    "Yeni YARIM": 0,
    "Yeni ÇEYREK": 0,
    "Eski ATA": 0,
    "Eski YARIM": 0,
    "Eski ÇEYREK": 0,
  };

  const out = {};

  for (const r of list) {
    const net = Number(r.borc || 0) - Number(r.alacak || 0);
    const tur = r.islemTur || "";

    const isAltinKarsiligi =
      tur === "NAKIT_ISLEM_GRAM_ALINDI" ||
      tur === "NAKIT_ISLEM_GRAM_VERILDI";

    if (!isAltinKarsiligi) {
      if (r.birim === "TL") tl += net;
      if (r.birim === "USD") usd += net;
      if (r.birim === "EUR") eur += net;
    }

    if (isAltinKarsiligi || r.birim === "GRAM" || tur.startsWith("ALTIN")) {
      gram += net;
    }

    if (tur.startsWith("ZIYNET") && r.stokAdi) {
      ziynet[r.stokAdi] += net;
    }

    let value = null;
    let type = r.birim;

    if (tur.startsWith("ALTIN") || isAltinKarsiligi) {
      type = "GRAM";
      value = gram;
    } else if (tur.startsWith("ZIYNET")) {
      type = `ZIYNET:${r.stokAdi}`;
      value = ziynet[r.stokAdi];
    } else if (r.birim === "TL") value = tl;
    else if (r.birim === "USD") value = usd;
    else if (r.birim === "EUR") value = eur;

    out[r.id] = { type, value };
  }

  return out;
};
